import React from "react";

const ScratchCodingKreatif: React.FC = () => {
  return (
    <div className="text-justify py-4 space-y-4">
      <h2 className="text-lg font-semibold mb-3">
        🚀 Program Coding Kreatif dan Inovasi
      </h2>
      <p>
        <a
          href="https://scratch.mit.edu/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline font-medium"
        >
          Scratch Coding
        </a>{" "}
        merupakan ajang kompetisi yang dirancang untuk memperkenalkan
        pemrograman secara kreatif dan menyenangkan bagi pelajar, khususnya sejak
        usia dini. Di tengah perkembangan dunia digital yang semakin pesat,
        kemampuan berpikir komputasional menjadi keterampilan dasar yang penting.{" "}
        <a
          href="https://scratch.mit.edu/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline font-medium"
        >
          Scratch
        </a>, sebagai bahasa pemrograman visual berbasis blok, memungkinkan
        siswa memahami konsep pemrograman tanpa harus berhadapan dengan sintaks
        yang rumit, sehingga proses belajar menjadi lebih inklusif dan mudah
        diakses.
      </p>

      <p>
        Melalui kompetisi{" "}
        <span className="font-medium">Scratch Coding</span> yang diselenggarakan
        dalam ekosistem{" "}
        <span className="font-medium">
          Indonesia Innovative Technology (IIT)
        </span>
        , peserta didorong menuangkan ide dan logika ke dalam program interaktif
        seperti animasi, permainan edukatif, simulasi sederhana, hingga cerita
        digital. Pendekatan visual drag-and-drop membantu siswa mempelajari
        konsep fundamental pemrograman seperti alur logika, perulangan,
        percabangan, dan variabel. Fondasi ini menjadi bekal penting bagi siswa
        sebelum melangkah ke pembelajaran bahasa pemrograman yang lebih lanjut.
      </p>

      <p>
        Pendekatan pembelajaran berbasis kompetisi terbukti efektif dalam
        menumbuhkan minat dan kreativitas siswa. Salah satu contohnya adalah{" "}
        <a
          href="https://www.darulmukmin-karimun.or.id/berhasil-buat-game-di-aplikasi-siswa-sds-017-it-darul-mukmin-karimun-juara-ii-lomba-coding-next-scratch-mini-competition-di-kota-batam/?utm_source=chatgpt.com"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline font-medium"
        >
          Next Scratch Mini Competition – “Monster Party”
        </a>{" "}
        yang diselenggarakan oleh Coding Next Batam pada 13 Oktober 2025.
        Kompetisi ini menantang siswa sekolah dasar untuk merancang game
        interaktif bertema “Monster Party” menggunakan Scratch serta
        mempresentasikan karya mereka di hadapan juri, sehingga melatih
        keberanian dan kemampuan komunikasi ide.
      </p>

      <p>
        Dari kompetisi tersebut, berbagai karya kreatif berhasil dihasilkan,
        mulai dari permainan edukatif hingga game sederhana dengan alur cerita
        interaktif. Prestasi yang diraih peserta menunjukkan bahwa{" "}
        <a
          href="https://scratch.mit.edu/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline font-medium"
        >
          Scratch Coding
        </a>
        {" "}tidak hanya menjadi sarana belajar teknis, tetapi juga media ekspresi
        kreativitas, logika berpikir, dan pemecahan masalah. Hal ini menegaskan
        bahwa pembelajaran coding dapat dimulai sejak dini dengan pendekatan
        yang menyenangkan dan bermakna.
      </p>

      <p>
        Sejalan dengan perkembangan teknologi dan meningkatnya kebutuhan akan
        literasi digital, pentingnya pembelajaran coding sejak dini juga
        mendapat perhatian pemerintah. Dorongan untuk mengenalkan coding di
        jenjang pendidikan dasar memperkuat peran{" "}
        <span className="font-medium">IIT</span> bersama{" "}
        <a
          href="https://edukasi.accelist.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline font-medium"
        >
          Accelist Edukasi Indonesia (AEDU)
        </a>{" "}
        dalam menghadirkan kompetisi dan ekosistem pembelajaran teknologi yang
        terstruktur dan berkelanjutan.Melalui Scratch Coding, pelajar tidak hanya belajar pemrograman, 
        tetapi juga mengembangkan kreativitas, kemampuan berpikir sistematis, dan
        kesiapan menghadapi tantangan teknologi di masa depan.
      </p>
    </div>
  );
};

export default ScratchCodingKreatif;
